const authority = 'https://stegoconnectpreview.b2clogin.com/tfp/stegoconnectpreview.onmicrosoft.com';
const signUpSignInPolicy = 'b2c_1a_signup_signin';
const resetPasswordPolicy = 'b2c_1_passwordreset';
const apiAuthURL = 'https://iot-dev.achtbytes.com';
const applicationURL = 'https://pressure-dev.achtbytes.com';
const authorityDomain = 'stegoconnectpreview.b2clogin.com';

const AAD_B2C_Policies = {
    names: {
        signUpSignIn: signUpSignInPolicy,
        resetPassword: resetPasswordPolicy,
    },
    authorities: {
        signUpSignIn: {
            authority: `${authority}/${signUpSignInPolicy}`,
        },
        resetPassword: {
            authority: `${authority}/${resetPasswordPolicy}`,
        },
    },
    authorityDomain: authorityDomain,
};

export const environment = {
    production: false,
    basePath: apiAuthURL,
    AzureActiveDirectory_B2C_AngularConfig: {
        AAD_ClientId: '09c64186-91ee-4e99-bd10-dbf8c4a4f814',
        AAD_Authority: authority,
        AAD_PostLogoutRedirectUri: applicationURL,
        AAD_ConsentScopes: {
            connectPortalAPI: 'https://stegoconnectpreview.onmicrosoft.com/api-access',
            openId: 'openid',
        },
        knownAuthorities: [AAD_B2C_Policies.authorityDomain],
        signUpSignInPolicy: signUpSignInPolicy,
        resetPasswordPolicy: resetPasswordPolicy,
        applicationURL: apiAuthURL,
        authorityDomain: authorityDomain,
        redirectUri: applicationURL + '/portal',
        b2cPolicies: AAD_B2C_Policies,
    },
    instrumentationKey: '',
    logLevel: 'trace',
    version: {
        environment: 'Local',
        number: '1.0',
    },
    disableConfirmationModalDelay: true,
    showNgxsLogs: false,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import 'zone.js/plugins/zone-error'; // Included with Angular CLI.
